import { render } from "./GeotabSetup.vue?vue&type=template&id=2fde3b9e&ts=true"
import script from "./GeotabSetup.vue?vue&type=script&lang=ts"
export * from "./GeotabSetup.vue?vue&type=script&lang=ts"

import "./GeotabSetup.vue?vue&type=style&index=0&id=2fde3b9e&lang=scss"

import exportComponent from "/home/nathan/public_html/accident-plan/accident-plan-api-whitelabel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__